import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  CancelTransactionRequestDto,
  CancelTransactionResponseDto,
  WsEvent,
  WsEventType,
} from '@sparling/financial-common'

export const {
  request: cancelTransactionRequest,
  success: cancelTransactionSuccess,
  failure: cancelTransactionFailure,
} = createAsyncAction('CANCEL_TRANSACTION_REQUEST', 'CANCEL_TRANSACTION_SUCCESS', 'CANCEL_TRANSACTION_FAILURE')<
  CancelTransactionRequestDto,
  CancelTransactionResponseDto,
  Error
>()

export const transactionStatusUpdated =
  createAction('TRANSACTION_STATUS_UPDATED')<WsEvent<WsEventType.USER_TRANSACTION_STATUS_UPDATED>['payload']>()
